/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          :  MyCart.tsx
*
* Project Title :  Checkout
*
* Description :
*
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : Avanthi G(E860178)
*
* @Date         : Jul 25, 2019
*
* @Version      : Version 1.0

* By            : Avanthi G (E860178)
* On            : Jul 30, 2019
* Description   : Added code to navigate to purchase software page Onclick of
*                 'Back to search' button in Mycart page and included
*                 Order Summary section  - ASDS-675, ASDS-676
* By            : Avanthi G (E860178)
* On            : Aug 02, 2019
* Description   : ProductList component added - ASDS-677.
*
* By            : H352615
* On            : Aug 13, 2019
* Description   : Integrated with Order Summary.
*
* By            : H352615
* On            : Aug 16, 2019
* Description   : Fixes ASDS-948.

* By            : E542450
* On            : Aug 28, 2019
* Description   : Integrate Generic Layout component in MyCart Page.

* By            : H224423
* On            : Oct 10, 2019
* Description   : ASDS-1478 - Grid level resposnive changes
*
* By            : H224423
* On            : Oct 03, 2019.
* Description   : ASDS-1478 - Dancing loader issue fix.
*
* By            : Deepthi B (E844276)
* On            : Oct 30, 2019
* Description   : Added the code for Empty cart notification - ASDS-1473
*
* By            : E807238
* On            : Nov 1, 2019
* Description   : ASDS-1693: Unable to delete product in cart
*
* By            : Sandeep Raja (E807238)
* On            : Nov 27, 2019
* Description   : ASDS-1948: Unable to fetch tax in My Cart Page
 *
 * By            : H224423
 * On            : Dec 3, 2019
 * Description   : ASDS-1995 - UI Issue Fixes. Restored Back to search button.
*
* By            : Madhu Gali - H175591
* On            : Dec 03 2019
* Description   : ASDS-1964
 * By            : H224423
 * On            : Dec 31 2019
 * Description   : MyCart UT Automation - loadpath variable - repeated snapshot update issue fix.
 *
 * By            : H224423
 * On            : Mar 12 2020
 * Description   : ASDS-2083 - Product Listing changes
 *
 * By            : H224423
 * On            : Apr 03 2020
 * Description   : ASDS-2190 - API error handling changes
 *
 * By            : H224423
 * On            : Apr 03 2020
 * Description   : ASDS-2190 - API error handling changes. Handled Edit cart item error scenario.
 *
 * By            : H422336
 * On            : Sep 07 2020
 * Description   : ASDS-2748 - UI Enhancements as part of Phase II
 *
 * By            : H422337
 * On            : Oct 09, 2020
 * Description   : ASDS - 3261 UI Enhancements for phase-2 bugfixes
 *
 * By            : H422336
 * On            : Oct 13, 2020
 * Description   : ASDS - 3262, ASDS-3263 UI Enhancements for Phase - II
 *
 * By            : H422336
 * On            : Oct, 16 2020
 * Description   : ASDS-3268 UI Enhancements for Phase-II
 *
 * By            : H422337
 * On            : Nov, 19 2020
 * Description   : ASDS-4083 UI Enhancements for Phase-II  bug fix & Delete All  products from the cart
 *
******************************************************************************/

import * as React from "react";
import { Grid, Button, Notification } from "@scuf/common";
import "@scuf/common/honeywell/theme.css";
import { RouteComponentProps, StaticContext, withRouter } from "react-router";
import "./MyCart.css";
import "@scuf/styles/variables.scss";
import OrderSummery from "../OrderSummery/OrderSummery";
import RouteConstants from "../constants/route-constants";
import RouteNames from "../constants/route-names";
import ProductList from "../ProductList/ProductList";
import { connect } from "react-redux";
import Layout from "../Layout/Layout";
import CheckoutConstants, {
  CheckoutUILabels,
} from "../constants/checkout-constants";
import CartDetailsActions from "../redux/actions/cart-details-actions";
import { ContactUsMessage } from "../Common/ContactUsMessage";
import TaxStatusMessage from "../OrderSummery/TaxStatusMessage";
import { NotifUpdateI, IBreadcrumbLink } from "../utils/checkout-interfaces";
import GenericLoader from "../Loader/Loader";
import BreadcrumbComponent from "../BreadcrumbComponent/BreadcrumbComponent";
import ProductAddedNotification from "../Notifications/ProductAddedNotification";
import ProductDeleteToastNotification from "../Notifications/ProductDeleteToastNotification";
import NonMSAPOProductsDeleteNotification from "../Notifications/NonMSAPOProductsDeleteNotification";
import ApplyCoupon from "../ApplyDiscount/ApplyCoupon";
import ApplyCouponActions from "../redux/actions/apply-coupon-actions";

interface ICartDetailState {
  open: any;
  hasClickOut: any;
  showCardContent: boolean;
  showShippingAndBilling: boolean;
}

interface ICartDetailProps {
  stateOptions?: any;
  content?: any;
  emptyCart: boolean;
  isFetching: boolean;
  isSuccess: boolean;
  errorOnDelete: boolean;
  errorOnEdit: boolean;
  lastDeleteProdName: string;
  lastEditProdName: string;
  hideErrorOndelete: Function;
  hideErrorOnEdit: Function;
  showDeleteMsg: Function;
  notifUpdateObj: NotifUpdateI;
  showAlertMsg: boolean;
  lastProdAddedToCart: string;
  isAddToCartSuccess: boolean;
  showDeleteMsgFlag: boolean;
  isProductDeleted: boolean;
  hasPriceChanged: boolean;
  deleteAllProductsSuccessFlag: boolean;
  notify: string;
  updatedeleteAllProductsSuccessFlag: Function;
  hasApplied: Function;
}

const ReactToastify = require("react-toastify");

export class MyCart extends React.Component<
  ICartDetailProps & RouteComponentProps,
  ICartDetailState
> {
  constructor(props: ICartDetailProps & RouteComponentProps) {
    super(props);
    this.state = {
      open: false,
      hasClickOut: true,
      showCardContent: false,
      showShippingAndBilling: false,
    };
    
    this.showPurchaseSoftware = this.showPurchaseSoftware.bind(this);
    this.showShippingAndBilling = this.showShippingAndBilling.bind(this);
    this.hideErrorOndelete = this.hideErrorOndelete.bind(this);
    this.hideErrorOnEdit = this.hideErrorOnEdit.bind(this);
  }


  componentDidUpdate() {
    if(this.props.emptyCart) {
      this.props.hasApplied(false);
    }
  }
  

  showPurchaseSoftware() {
    this.hideErrorOndelete();
    this.hideErrorOnEdit();
    this.props.history.push(RouteConstants.PURCHASE_SOFTWARE);
  }
  showShippingAndBilling() {
    this.hideErrorOndelete();
    this.hideErrorOnEdit();
    this.props.history.push(RouteConstants.SHIPPING_BILLING);
  }

  hideErrorOndelete() {
    this.props.hideErrorOndelete();
  }
  hideErrorOnEdit() {
    this.props.hideErrorOnEdit();
  }
  errorContent = () => {
    let errorObj;

    if (!this.props.isFetching && !this.props.isSuccess) {
      errorObj = (
        <Grid.Row data-testid="t-Mycart-error-notification">
          <Grid.Column width={12}>
            <Notification
              hasIcon={true}
              title="There is an error in processing your request."
              severity="critical"
              detailsText="RELOAD THE PAGE"
              onDetailsClick={() => window.location.reload()}
            >
              <ContactUsMessage>
                {CheckoutUILabels.IF_ISSUE_PERSISTS}
              </ContactUsMessage>
            </Notification>
          </Grid.Column>
        </Grid.Row>
      );
    } else if (this.props.emptyCart) {
      errorObj = (
        <Grid.Row className="col-12">
          <Grid.Column width={12}>
            <Notification
              severity="information"
              hasIcon={true}
              title={CheckoutConstants.EMPTY_CART_MESSAGE}
              detailsText="BACK TO PRODUCT LISTING"
              onDetailsClick={this.showPurchaseSoftware}
            >
              <p>Please add products in your cart to checkout.</p>
            </Notification>
          </Grid.Column>
        </Grid.Row>
      );
    } else if (this.props.notifUpdateObj.notifDisplayFlag) {
      errorObj = (
        <Grid.Row data-testid="t-Mycart-notification">
          <Grid.Column width={12}>
            <Notification
              hasIcon={true}
              title={this.props.notifUpdateObj.notifDisplayMsg}
              severity="important"
            />
          </Grid.Column>
        </Grid.Row>
      );
    } else {
      // display error based on tax reponse, when the cart is not empty.
      errorObj = (
        <TaxStatusMessage
          severity={CheckoutUILabels.NOTIFICATION_SEVERITY_IMPORTANT}
        />
      );
    }
    return errorObj;
  };

  notify(value: boolean) {
    if (this.props.showDeleteMsgFlag) {
      ReactToastify.toast(
        <ProductDeleteToastNotification success={value} closeToast={false} />
      );
      this.props.showDeleteMsg(false);
    }
  }
  deleteAllProductNotify() {
    if (this.props.deleteAllProductsSuccessFlag) {
      ReactToastify.toast(
        <NonMSAPOProductsDeleteNotification
          closeToast={false}
          msgTitle={CheckoutUILabels.PRODUCT_PRICE_UPDATE}
          msgBody={CheckoutUILabels.DELETE_ALL_MSA_PRODUCT}
        />
      );
    }
  }

  render() {
    const breadcrumbsList: Array<IBreadcrumbLink> = [
      { location: RouteNames.PURCHASE_SOFTWARE },
      { location: RouteNames.MY_CART },
    ];
    let errorObj = this.errorContent();

    if (this.props.isSuccess) {
      this.notify(this.props.isProductDeleted);
    }

    if (this.props.deleteAllProductsSuccessFlag) {
      this.deleteAllProductNotify();
      setTimeout(() => {
        this.props.updatedeleteAllProductsSuccessFlag(false);
      }, 200);
    }

    return (
      <Layout>
        {/******************banner starts here*************/}
        <div>
          <ReactToastify.ToastContainer
            hideProgressBar={true}
            closeOnClick={false}
            closeButton={false}
            newestOnTop={true}
            position={this.props.notify}
            toastClassName={
              "toast-notification-wrap" +
              (this.props.notify === "top-right" ? " product-price" : "")
            }
          />
        </div>
        {/******************body of the page  starts here*************/}
        {this.props.isFetching && (
          <GenericLoader
            text="Fetching Cart details"
            className="mycart-loader"
            loading={true}
            overlayColor="rgb(247, 247, 247)"
          />
        )}
        <Grid.Row>
          <Grid.Column width={12} className="fullwidthRow">
            <Grid>
              <Grid.Row className="fullwidthRow">
                <Grid.Column width={12} className="paddingZero">
                  <BreadcrumbComponent breadcrumbs={breadcrumbsList} />
                </Grid.Column>
                <Grid.Column className="my-cart-heading" width={12}>
                  <h1 className="centerAlign pageHeading">My Cart</h1>
                </Grid.Column>
              </Grid.Row>
              {errorObj}
              {/******************first card  starts here*************/}
              {this.props.showAlertMsg && (
                <ProductAddedNotification
                  productCtg={this.props.lastProdAddedToCart}
                  isAddToCartSuccess={this.props.isAddToCartSuccess}
                />
              )}
              {!this.props.isFetching &&
                this.props.isSuccess &&
                !this.props.emptyCart && (
                  <Grid.Row className="fullwidthRow">
                    <Grid.Column
                      className="cart-list-panel card-details-info"
                      width={9}
                      mWidth={12}
                      xsWidth={12}
                    >
                      {/****************** List of selected Products ************ */}

                      <ProductList page="myCart" />
                    </Grid.Column>
                    {/******************right part for order summary  starts here************ */}
                    <Grid.Column
                      className="order-summary-panel"
                      width={3}
                      mWidth={12}
                      sWidth={12}
                    >
                      <Grid.Row className="fullwidthRow">
                      <Grid.Column
                      className="order-summary-panel"
                      width={12}
                      mWidth={12}
                      sWidth={12}
                    >
                      <OrderSummery>
                        <Button
                          data-testid="proceedToCheckOut-btn"
                          type="primary"
                          content="PROCEED TO CHECKOUT"
                          className="fullWidthButton co-primary-button"
                          onClick={this.showShippingAndBilling}
                        />
                      </OrderSummery>
                    </Grid.Column>
                      
                      <Grid.Column
                      className="order-summary-panel"
                      width={12}
                      mWidth={12}
                      sWidth={12}
                    >
                      {/* <OrderSummery>
                        <Button
                          data-testid="proceedToCheckOut-btn"
                          type="primary"
                          content="Apply Coupon"
                          className="fullWidthButton co-primary-button"
                          onClick={this.showShippingAndBilling}
                        />
                      </OrderSummery> */}
                      <ApplyCoupon />
                    </Grid.Column>
                      </Grid.Row>
                      {/* <OrderSummery>
                        <Button
                          data-testid="proceedToCheckOut-btn"
                          type="primary"
                          content="PROCEED TO CHECKOUT"
                          className="fullWidthButton co-primary-button"
                          onClick={this.showShippingAndBilling}
                        />
                      </OrderSummery> */}
                    </Grid.Column>
                    {/*****************right part for order summary  ends here*************/}

                  </Grid.Row>
                )}
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Layout>
    );
  }
}

function mapStateToProps(store) {
  
  const {
    isFetching,
    isSuccess,
    cartDetails = {},
  } = store.cartDetails.abstractView;
  const notifUpdateObj = store.configAPUData.payload.contractExpireNotif;
  if (!isFetching && isSuccess) {
    return {
      isFetching,
      isSuccess,
      emptyCart: cartDetails.cartList
        ? cartDetails.cartList.length === 0
        : false,
      errorOnDelete: store.cartDetails.errorOnDelete,
      errorOnEdit: store.cartDetails.errorOnEdit,
      lastEditProdName: store.cartDetails.lastEditProdName,
      lastDeleteProdName: store.cartDetails.lastDeleteProdName,
      notifUpdateObj,
      showAlertMsg: store.productAlertData.payload.showAlertMsg,
      lastProdAddedToCart: store.productAlertData.payload.lastProdAddedToCart,
      isAddToCartSuccess: store.productAlertData.payload.isAddToCartSuccess,
      showDeleteMsgFlag: store.cartDetails.showDeleteMsgFlag,
      isProductDeleted: store.cartDetails.isProductDeleted,
      hasPriceChanged: store.cartDetails.hasPriceChanged,
      deleteAllProductsSuccessFlag:
        store.cartDetails.deleteAllProductsSuccessFlag,
      notify: store.cartDetails.notify,
    };
  }
  return {
    isFetching,
    isSuccess,
    emptyCart: false,
    notifUpdateObj,
    showAlertMsg: store.productAlertData.payload.showAlertMsg,
    lastProdAddedToCart: store.productAlertData.payload.lastProdAddedToCart,
    isAddToCartSuccess: store.productAlertData.payload.isAddToCartSuccess,
    showDeleteMsgFlag: store.cartDetails.showDeleteMsgFlag,
    isProductDeleted: store.cartDetails.isProductDeleted,
    deleteAllProductsSuccessFlag:
      store.cartDetails.deleteAllProductsSuccessFlag,
    notify: store.cartDetails.notify,
  };
}

const mapDispatchToProps = {
  hideErrorOndelete: CartDetailsActions.hideErrorOndeleteProduct,
  hideErrorOnEdit: CartDetailsActions.hideErrorOnEditProduct,
  showDeleteMsg: CartDetailsActions.showDeleteMsg,
  updatedeleteAllProductsSuccessFlag:
    CartDetailsActions.updatedeleteAllProductsSuccessFlag,
  hasApplied: ApplyCouponActions.hasApplied,

};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyCart));
